import styled from 'styled-components';

interface StyledProps {
  $leftOpen?: boolean;
  $rightOpen?: boolean;
}

export const Layout = styled.div<StyledProps>`
  display: flex;
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  margin-top: -1px;
`;


export const MainContent = styled.div<StyledProps>`
  flex: 1;
  margin-left: ${({ $leftOpen }) => ($leftOpen ? '232px' : '50px')};
  margin-right: ${({ $rightOpen }) => ($rightOpen ? '232px' : '50px')};
  transition: all 0.3s ease-in-out;
  width: calc(
    100% -
      ${({ $leftOpen, $rightOpen }) =>
        ($leftOpen ? '250px' : '50px') +
        ' - ' +
        ($rightOpen ? '250px' : '50px')}
  );

  @media (max-width: 768px) {
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    width: calc(100% - 100px);
  }
`;

export const ProgressBarWrapper = styled.div`
  width: 100%;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.backgroundDark};
`;
